import React from 'react'
import { MDAlert } from '../../../../../Component/Common/Components/MDAlert';
import { MDBox } from '../../../../../Component/Common/Components/MDBox';
import { MDTypography } from '../../../../../Component/Common/Components/MDTypography';
import { TrainingImportModal } from './TrainingImportModal';
import { DataImportType } from '../../../../../Component/Model/Enum/BEE123Enums';
import { Button, Grid } from '@mui/material';

interface IProps {
    fetchData?: () => void;
    organisationId: number;
    dataImportType: DataImportType;
}
export const TrainingImportButtons = (props: IProps) => {
    const [isImportModalOpen, setIsImportModalOpen] = React.useState(false);

    const closeImportModal = () => {
        setIsImportModalOpen(false);

        if (props.fetchData) {
            props.fetchData();
        }
    }

    return (
        <>
            <Grid item xs={12} lg={12}>
                <MDBox mt={4} color="white">
                    <MDAlert color='light'>
                        <MDTypography component='span' variant='body' fontSize='0.93rem' fontWeight='regular'>
                            <p style={{ marginBottom: "0.2rem" }}> Click<Button variant="text" onClick={() => {
                                setIsImportModalOpen(true);
                            }} size="small" style={{ fontSize: "inherit", padding: "0.25rem", paddingBottom: "0.4rem", minWidth: "0", textTransform: "none" }}>here</Button>
                                to Import data from a file</p>
                        </MDTypography>
                    </MDAlert>
                </MDBox>
            </Grid>
            {isImportModalOpen &&
                <TrainingImportModal open={isImportModalOpen} closeModal={closeImportModal} dataImportType={props.dataImportType} organisationId={props.organisationId} />
            }
        </>
    )
}
